import { disposeMesh, disposeObject } from 'src/utils/object3DHelpers';
import { SceneComponent, Inputs, ComponentInteractionType } from './types';

export const editButtonType = 'treedis.editButton';

export class EditButton extends SceneComponent {
  private root: any = null;

  private pivot: any = null;

  private button: any = null;

  inputs: Inputs = {
    src: null,
    size: 0.02,
    localPosition: null,
    visible: true,
  };

  // setting which events are compatible with the component
  events = {
    [ComponentInteractionType.CLICK]: true,
    [ComponentInteractionType.HOVER]: true,
    [ComponentInteractionType.DRAG]: false,
  };

  onInit() {
    const THREE = this.context.three;
    this.root = new THREE.Object3D();
    this.pivot = new THREE.Object3D();
    this.outputs.objectRoot = this.root;
    // setting the collider to allow events
    this.outputs.collider = this.root;
    this.root.add(this.pivot);

    this.root.name = editButtonType;

    const { src } = this.inputs;
    this.makeBtn(src);
  }

  onDestroy() {
    if (this.button) {
      disposeMesh(this.button);
      this.button = null;
    }

    if (this.root) {
      disposeObject(this.root);
      this.root = null;
    }
  }

  private makeBtn(url: string | null) {
    if (this.button) {
      disposeMesh(this.button);
      this.button = null;
    }
    const THREE = this.context.three;
    const { size, localPosition } = this.inputs;

    const geometry = new THREE.CircleGeometry(size, 128);
    // const _this = this;
    new THREE.TextureLoader().load(
      url,
      // onLoad callback
      (texture) => {
        try {
          if (texture != null && texture.isTexture) {
            // eslint-disable-next-line no-multi-assign
            texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
            texture.encoding = THREE.LinearEncoding;
            texture.repeat.set(1, 1);
            //            texture.needsUpdate = true;
            // _this.context.renderer.initTexture(texture);
            if (texture.image.width == 0 || texture.image.height == 0) {
              //console.error('Unable to get image resolution.',texture);
              throw new Error('Unable to get image resolution.');
            }
            //if for max tex Size
            if (
              texture.image.width > this.context.renderer.capabilities.maxTextureSize ||
              texture.image.height > this.context.renderer.capabilities.maxTextureSize
            ) {
              texture.image.height =
                texture.image.height *
                (texture.image.height / this.context.renderer.capabilities.maxTextureSize);
              texture.image.width =
                texture.image.width *
                (texture.image.width / this.context.renderer.capabilities.maxTextureSize);
            }
            const material = new THREE.MeshBasicMaterial({
              map: texture,
              side: THREE.DoubleSide,
              blending: THREE.NormalBlending,
              transparent: true,
              polygonOffset: true,
              polygonOffsetUnits: -4,
            });
            this.button = new THREE.Mesh(geometry, material);
            this.root.add(this.button);

            if (localPosition) {
              this.button.position.set(localPosition.x, localPosition.y, localPosition.z);
            }
          }
        } catch (e) {
          console.log('[Err] An error happened during texture init.', e);
        }
      },
      // onProgress callback currently not supported
      undefined,
      // onError callback
      function (err) {
        console.error('[Err] An error happened during texture load.', err);
      },
    );
  }
}

export function makeEditButton(): any {
  return new EditButton();
}
